import { useNavigate } from 'react-router-dom';

import { viewFactory } from '@/utils';

import { AdminUsersListView } from './AdminUsersListView';
import { useAdminUsersListQuery } from './hooks';

const AdminUsersListContainer = () => {
    const navigate = useNavigate();
    const query = useAdminUsersListQuery();

    return viewFactory(AdminUsersListView, query, {
        onBack: () => navigate('/'),
    });
};

export { AdminUsersListContainer };
